module.exports = __webpack_public_path__ + "img/Icon-ionic-md-key.8c4a9e46.svg";